import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 250 } }

  connect() {
    this.submitTimer = null
  }

  disconnect() {
    this.clearTimer()
  }

  queueSubmit() {
    this.clearTimer()
    this.submitTimer = window.setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }

  submitNow() {
    this.clearTimer()
    this.element.requestSubmit()
  }

  clearTimer() {
    if (this.submitTimer) {
      window.clearTimeout(this.submitTimer)
      this.submitTimer = null
    }
  }
}
